import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricLivePricingNotTriggeredCount extends MetricBase {
    constructor() {
        super({
            field: "metric_livePricingNotTriggeredCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.livePricingNotTriggeredCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.livePricingNotTriggeredCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.livePricingNotTriggeredCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricLivePricingNotTriggeredCount;
